import { render } from "./enrolments-table-filter.vue?vue&type=template&id=6d9182d0&ts=true"
import script from "./enrolments-table-filter.ts?vue&type=script&lang=ts&external"
export * from "./enrolments-table-filter.ts?vue&type=script&lang=ts&external"

import "./enrolments-table-filter.scss?vue&type=style&index=0&lang=scss&external"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__